import { api } from 'common';

import { CreateNotableObjectFormFields } from './FormFields';
import { CreateNotableObjectDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const createNotableObjectConfig: BlockConfigProps<
  api.FlowDefinition.CreateNotableObjectBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'CreateNotableObject',
  defaultConfig: {
    notableObject: api.FlowDefinition.NotableObject.Patient,
    payload: '',
  },
  configFields: {
    schema: api.FlowDefinition.CreateNotableObjectConfigSchema,
    FormFields: CreateNotableObjectFormFields,
  },
  documentationMarkdown: CreateNotableObjectDocumentationMarkdown,
};
